module.exports = __webpack_public_path__ + "img/79.77e28a44.png";